import { postUpdateMessanger } from '../api/postUpdateMessanger';


const setPostUpdateMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateMessanger(params);
            window.location.replace('/settings/messanger')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateMessanger
}